import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";
import _defineProperty from "E:/workspaces/shop-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 商品列表
 * @author shendeying
 */
import BackEventMixins from '~/mixins/back-event-mixins';
import config from '$config';
import api from 'api/priceAnalyse';
import CommonUtils from 'utils/CommonUtils';
import { mapMutations, mapGetters } from 'vuex';
import { GET_SCREEN } from '$getters';
import { SET_NAV_CALLBACK } from '$mutations';
export default {
  name: 'page-goods-list',
  mixins: [BackEventMixins],
  data: function data() {
    return {
      currentType: null,
      typeList: null,
      showList: false,
      pageConfig: {
        page: 1,
        size: 100,
        templateId: 2
      },
      list: [],
      fetchFun: api.priceAnalysePage,
      isFromCategory: false // 是否从分类页跳转至此

    };
  },
  computed: _objectSpread({
    fileURL: function fileURL() {
      return config.fileURL;
    }
  }, mapGetters({
    screen: GET_SCREEN
  })),
  watch: {
    '$route.path': function $routePath(val, old) {
      if (old === '/goodsDetail' && this.list.length === 0) {
        this.fetchFun();
      }
    },
    currentType: function currentType(val, oldVal) {
      if (oldVal) {
        this.query(val);
      }
    }
  },
  methods: _objectSpread(_objectSpread({
    getStock: CommonUtils.getStock,
    formatDate: CommonUtils.format
  }, mapMutations([SET_NAV_CALLBACK])), {}, {
    sortId: function sortId(a, b) {
      return a.orderNum - b.orderNum;
    },
    flushList: function flushList() {
      this.$refs.list.flushList();
    },
    fetchData: function fetchData() {
      this.$refs.list.fetchData();
    },
    query: function query(index) {
      if (Number(index)) {
        this.pageConfig.templateId = index;
      } else {
        this.pageConfig.templateId = null;
      }

      this.flushList();
    },
    view: function view(goodscode, goodsId, templateId) {
      this.$router.push({
        path: '/goodsPriceHistory',
        query: {
          goodscode: goodscode,
          goodsId: goodsId,
          templateId: templateId
        }
      });
    },
    // 截取当前数据到小数点后两位
    numFilter: function numFilter(value) {
      var realVal = parseFloat(value).toFixed(2);
      return realVal;
    },
    backFun: function backFun() {
      if (this.isFromCategory) {
        this.$router.push({
          path: '/category'
        });
      } else {
        this.$router.push({
          path: '/home'
        });
      }
    },
    getdate: function getdate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();

      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }

      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }

      var currentdate = year + "-" + month + "-" + strDate;
      return currentdate;
    }
  }),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      // vm.$nextTick(() => {
      //   if (vm.$refs.list) {
      //     console.log('vm.$refs.list: ', vm.$refs.list)
      //     window.document.getElementById('list').scrollTop = 180
      //   }
      // })
      vm.$nextTick(function () {
        vm.showList = true;
      });
    });
  },
  mounted: function mounted() {},
  components: {}
};